import { PopularTheaterAPI } from '../typings/api';
import Theatre from './Theatre';

interface PopularPlay {
  id: number;
  theatre: number;
  poster_url: string;
}

class PopularTheatre implements PopularTheaterAPI {
  most_popular_plays: PopularPlay[];
  this_week: Theatre[];
  most_popular_theatres: Theatre[];

  public getPopularPlay(id: number): PopularPlay {
    return this.most_popular_plays.find((play) => play.theatre === id);
  }

  static fromJSON(json: PopularTheaterAPI): PopularTheatre {
    return Object.assign(new PopularTheatre(), json);
  }
}

export default PopularTheatre;
